import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ImageData, ImagesService, Resolution } from '@libraries/assets';
import { isMobile } from '@libraries/ui-state';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'generic-page',
  templateUrl: './generic-page.component.html',
  styleUrls: ['./generic-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenericPageComponent implements OnChanges {
  @Input() image: string;
  @Input() hidePortalMenu = false;
  @Input() showAppHeader = true;
  @Input() showImage = true;
  @Input() showTucieloLogo = false;

  @HostBinding('class.column-layout')
  @Input()
  columnLayout = true;

  imageData$: Observable<ImageData>;
  imageChanges = new BehaviorSubject('');

  resolution: Resolution;
  resolutionChanges = this.store.select(isMobile).pipe(tap(this.updateResolution.bind(this)));

  get isMobile() {
    return this.resolution === Resolution.mobile;
  }

  constructor(private store: Store, public images: ImagesService) {
    this.imageData$ = combineLatest([this.imageChanges, this.resolutionChanges]).pipe(
      filter(() => Boolean(this.resolution)),
      switchMap(() => {
        if (!this.image) {
          // passing undefined so the template does not try and render the `background` div, which causes page content to be unclickable
          return of(undefined);
        } else {
          return this.images.get$(this.image + this.resolution);
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.image && changes.image.previousValue !== changes.image.currentValue) {
      this.imageChanges.next(changes.image.currentValue);
    }
  }

  updateResolution(mobile: boolean) {
    this.resolution = mobile ? Resolution.mobile : Resolution.desktop;
  }
}
